"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getToggleUtilityClass = getToggleUtilityClass;
exports.switchClasses = void 0;
var _base = require("@ori-ui/mui-bundle/base");
function getToggleUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriToggle', slot);
}
const switchClasses = exports.switchClasses = (0, _base.generateUtilityClasses)('MuiOriToggle', ['root', 'fullWidth', 'text', 'textActive', 'indicator', 'disabled', 'indicatorActive', 'checkbox', 'icon']);
var _default = exports.default = switchClasses;
